module.exports = __webpack_public_path__ + "static/media/013_IMG_1885.6d9b5cfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/mashery/013_IMG_1885.png
// module id = 560
// module chunks = 0